import { Box, Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import { ContactsReport } from '../components/reports/ContactsReport.tsx';
import { Link as RouterLink } from 'react-router';

const ContactsReportPage = () => {
  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/reports">
          Reports
        </MuiLink>
        <Typography color="text.primary">Contacts Report</Typography>
      </Breadcrumbs>
      <Box my={2}>
        <Typography variant="h4" gutterBottom>
          Contacts Report
        </Typography>
        <ContactsReport />
      </Box>
    </Container>
  );
};

export default ContactsReportPage;
